import {
	Activity,
	AtSign,
	Ban,
	Bell,
	DollarSign,
	HelpingHand,
	Lock,
	MessageCircle,
	MessagesSquare,
	ShieldCheck,
	Sparkle,
	Star,
	User,
} from 'lucide-react'
import * as React from 'react'
import { Link, Outlet, useLocation } from 'react-router'
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from '#app/components/ui/breadcrumb.tsx'
import { Separator } from '#app/components/ui/separator.tsx'
import {
	Sidebar,
	SidebarContent,
	SidebarGroup,
	SidebarGroupContent,
	SidebarGroupLabel,
	SidebarHeader,
	SidebarMenu,
	SidebarMenuButton,
	SidebarMenuItem,
	SidebarRail,
} from '#app/components/ui/sidebar'
import {
	SidebarInset,
	SidebarProvider,
	SidebarTrigger,
} from '#app/components/ui/sidebar.tsx'

export default function SettingsLayout() {
	return (
		<SidebarProvider>
			<AppSidebar className="left-58" />
			<SidebarInset>
				<header className="sticky top-0 flex h-16 shrink-0 items-center gap-2 border-b bg-background px-4">
					<SidebarTrigger className="-ml-1" />
					<Separator orientation="vertical" className="mr-2 h-4" />
					<Breadcrumb>
						<BreadcrumbList>
							<BreadcrumbItem className="hidden md:block">
								<BreadcrumbLink href="#">Account</BreadcrumbLink>
							</BreadcrumbItem>
							<BreadcrumbSeparator className="hidden md:block" />
							<BreadcrumbItem>
								<BreadcrumbPage>Profile</BreadcrumbPage>
							</BreadcrumbItem>
						</BreadcrumbList>
					</Breadcrumb>
				</header>
				<Outlet />
			</SidebarInset>
		</SidebarProvider>
	)
}

const data = {
	navMain: [
		{
			title: 'How you use Intermave',
			url: '#',
			items: [
				{
					title: 'Edit profile',
					url: '/settings/account',
					icon: User,
					isActive: true,
				},
				{
					title: 'Notifications',
					url: '/settings/notifications',
					icon: Bell,
				},
				{
					title: 'Subscription',
					url: '/settings/subscription',
					icon: Sparkle,
				},
				{
					title: 'Payments',
					url: '/settings/payments',
					icon: DollarSign,
				},
			],
		},
		{
			title: 'Who can see your account',
			url: '#',
			items: [
				{
					title: 'Account privacy',
					url: '/settings/account-privacy',
					icon: Lock,
				},
				{
					title: 'Connections',
					url: '/settings/connections',
					icon: Star,
				},
				{
					title: 'Blocked',
					url: '/settings/blocked',
					icon: Ban,
				},
			],
		},
		{
			title: 'How others interact with you',
			url: '#',
			items: [
				{
					title: 'Messages',
					url: '/settings/messages',
					icon: MessagesSquare,
				},
				{
					title: 'Tags & mentions',
					url: '/settings/tags-and-mentions',
					icon: AtSign,
				},
				{
					title: 'Comments',
					url: '/settings/comments',
					icon: MessageCircle,
				},
			],
		},
		{
			title: 'More info and support',
			url: '#',
			items: [
				{
					title: 'Help',
					url: '/settings/help',
					icon: HelpingHand,
				},
				{
					title: 'Privacy center',
					url: '/settings/privacy-center',
					icon: ShieldCheck,
				},
				{
					title: 'Account status',
					url: '/settings/account-status',
					icon: Activity,
				},
			],
		},
	],
}

function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
	const { pathname } = useLocation()

	return (
		<Sidebar {...props}>
			<SidebarHeader>
				<h1 className="mt-3 px-2 text-xl font-semibold">Settings</h1>
			</SidebarHeader>
			<SidebarContent className="gap-3">
				{/* We create a collapsible SidebarGroup for each parent. */}
				{data.navMain.map((item) => (
					<div key={item.title} title={item.title}>
						<SidebarGroup>
							<SidebarGroupLabel className="group/label mb-1.5 text-left text-xs font-normal text-muted-foreground">
								{item.title}
							</SidebarGroupLabel>
							<SidebarGroupContent>
								<SidebarMenu>
									{item.items.map((item) => (
										<SidebarMenuItem key={item.title}>
											<SidebarMenuButton
												asChild
												isActive={pathname === item.url}
											>
												<Link to={item.url} className="flex gap-1.5">
													{item.icon && <item.icon className="h-5 w-5" />}
													{item.title}
												</Link>
											</SidebarMenuButton>
										</SidebarMenuItem>
									))}
								</SidebarMenu>
							</SidebarGroupContent>
						</SidebarGroup>
					</div>
				))}
			</SidebarContent>
			<SidebarRail />
		</Sidebar>
	)
}
